import React from 'react';
import { withTheme } from '@material-ui/core/styles/index';

const FancyCard = ({ className, children, theme, barColor, fullWidth }) => {
    return (
        <div
            style={{
                borderLeft: `6px solid ${barColor || theme.palette.primary.main}`,
                borderTop: 'solid 1px #dddddd',
                borderBottom: 'solid 1px #dddddd',
                borderRadius: 0,
                ...(fullWidth ? { width: '100%' } : {})
            }}
            className={className}
        >
            {children}
        </div>
    );
};

export default withTheme(FancyCard);
